<template>
  <div id="app">
    <v-app id="inspire">
      <v-card-title>
        <span class="headline">{{ formTitle}}</span>
      </v-card-title>
      <v-container grid-list-xl>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation>
          <v-tabs
            grow
            slider-color="blue"
            color="#eeeeee">
            <v-tab ripple>
                Informações
            </v-tab>
            <v-tab ripple>
                Troca de Tributos
            </v-tab>
            <v-tab ripple>
                CST
            </v-tab>
            <v-tab-item>
                <v-layout
                    class="mt-3"
                    row
                    align-end
                    justify-space-between
                >
                    <v-flex xs12 sm12 md5>
                    <v-text-field v-model="newPosicao.codigo" counter="15" :rules="tamanhoRules" label="Código"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                         <v-text-field
                            v-model="newPosicao.empresas_id.nome"
                            label="Empresas"
                            readonly
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    align-end
                    justify-space-between
                >
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newPosicao.nome" label="Nome"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                         <v-combobox
                            v-model="newPosicao.tp_doc"
                            :items="tipoDocumento"
                            label="Documento Fiscal"
                            hide-no-data
                            hide-selected
                            item-text="nome"
                            item-value="id"
                            placeholder="Comece a digitar para procurar"
                            return-object
                        >
                        </v-combobox>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    align-end
                    justify-space-between
                >
                    <v-flex xs12 sm12 md5>
                        <v-combobox
                            v-model="newPosicao.tp_nf"
                            :items="tipoNota"
                            label="Tipo de nota"
                            hide-no-data
                            hide-selected
                            item-text="nome"
                            item-value="id"
                            placeholder="Comece a digitar para procurar"
                            return-object
                        >
                        </v-combobox>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                         <v-combobox
                            v-model="newPosicao.tp_finNFe"
                            :items="tipoFinalidade"
                            label="Finalidade de Emissão da NF-e"
                            hide-no-data
                            hide-selected
                            item-text="nome"
                            item-value="id"
                            placeholder="Comece a digitar para procurar"
                            return-object
                        >
                        </v-combobox>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    align-end
                    justify-space-between
                >
                    <v-flex xs12 sm12 md5>
                         <v-combobox
                            v-model="newPosicao.tp_idDest"
                            :items="tipoDestino"
                            label="Local de destino da Operação"
                            hide-no-data
                            hide-selected
                            item-text="nome"
                            item-value="id"
                            placeholder="Comece a digitar para procurar"
                            return-object
                        >
                        </v-combobox>
                    </v-flex>
                    <v-flex xs12 sm12 md5>
                        <v-text-field v-model="newPosicao.natOpe" label="Natureza da Operação"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                >
                    <v-flex xs12 sm12 md5>
                        <v-textarea v-model="newPosicao.observacoes"
                            id = "observacao"
                            name="observacao"
                            label="Observações"
                        ></v-textarea>
                    </v-flex>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <v-layout class="mt-5">
                    <v-flex md12 >
                        <div column justify-space-between>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Troca de Tributos</v-toolbar-title>
                                <v-divider class="mx-2" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog1" max-width="500px">
                                    <v-btn slot="activator" color="primary" dark class="mb-2"> Novo</v-btn>
                                    <v-card>
                                    <v-card-title>
                                        <span class="headline">Cadastrar tributo</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container grid-list-lg>
                                            <v-layout wrap>
                                                 <v-flex xs12 sm12 md12>
                                                    <v-combobox
                                                        v-model="editedItem.ncm_id"
                                                        :items="ncmT"
                                                        label="Código NCM"
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :search-input.sync="searchNcmT"
                                                        :loading="loadingNcmT"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap>
                                                <v-flex xs12 sm12 md6>
                                                    <v-combobox
                                                        v-model="editedItem.tributo_from"
                                                        :items="tipoTributos"
                                                        label="Código do imposto que será trocado* "
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :search-input.sync="searchTributo"
                                                        :loading="loadingTributo"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12 sm12 md6>
                                                    <v-combobox
                                                        v-model="editedItem.tributo_to"
                                                        :items="tipoTributosTo"
                                                        label="Código do imposto substituto"
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :search-input.sync="searchTributoTo"
                                                        :loading="loadingTributoTo"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" flat @click="close">Fechar</v-btn>
                                        <v-btn color="blue darken-1" flat @click="save">Salvar</v-btn>
                                    </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </div>
                        <v-data-table
                            :headers="headers1"
                            :items="troca_tibutos"
                            class="elevation-1"
                        >
                            <template slot="items" slot-scope="props">
                            <td class="align left">{{ props.item.ncm_id.nome }}</td>
                            <td>{{ props.item.tributo_from.nome }}</td>
                            <td v-if="props.item.tributo_to">{{ props.item.tributo_to.nome }}</td>
                                <td else>&nbsp;</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                small
                                class="mr-2"
                                @click="editItem(props.item)"
                                >
                                edit
                                </v-icon>
                                <v-icon
                                small
                                @click="deleteItem(props.item)"
                                >
                                delete
                                </v-icon>
                            </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <v-layout class="mt-5">
                    <v-flex md12 >
                        <div column justify-space-between>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>CST</v-toolbar-title>
                                <v-divider class="mx-2" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog2" max-width="500px">
                                    <v-btn slot="activator" color="primary" dark class="mb-2"> Novo</v-btn>
                                    <v-card>
                                    <v-card-title>
                                        <span class="headline">Cadastrar</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container grid-list-lg>
                                            <v-layout wrap>
                                                 <v-flex xs12 sm12 md12>
                                                    <v-combobox
                                                        v-model="editedItem2.ncm_id"
                                                        :items="ncm"
                                                        label="Código NCM"
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :loading="loadingNcm"
                                                        :search-input.sync="searchNcm"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap>
                                                <v-flex xs12 sm12 md6>
                                                    <v-combobox
                                                        v-model="editedItem2.cfop"
                                                        :items="tipoCfop"
                                                        label="CFOP*"
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :loading="loadingCfop"
                                                        :search-input.sync="searchCfop"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12 sm12 md6>
                                                    <v-combobox
                                                        v-model="editedItem2.cst_icms"
                                                        :items="tipoIcms"
                                                        label="CST ICMS*"
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :loading="loadingIcms"
                                                        :search-input.sync="searchIcms"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap>
                                                <v-flex xs12 sm12 md6>
                                                    <v-combobox
                                                        v-model="editedItem2.cst_ipi"
                                                        :items="tipoIpi"
                                                        label="CST da ipi*"
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :loading="loadingIpi"
                                                        :search-input.sync="searchIpi"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                                <v-flex xs12 sm12 md6>
                                                    <v-combobox
                                                        v-model="editedItem2.cst_pis"
                                                        :items="tipoPis"
                                                        label="CST da pis*"
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :loading="loadingPis"
                                                        :search-input.sync="searchPis"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap>
                                                <v-flex xs12 sm12 md5>
                                                    <v-combobox
                                                        v-model="editedItem2.cst_cofins"
                                                        :items="tipoCofins"
                                                        label="CST da cofins*"
                                                        hide-no-data
                                                        hide-selected
                                                        item-text="nome"
                                                        item-value="id"
                                                        placeholder="Comece a digitar para procurar"
                                                        return-object
                                                        :loading="loadingCofins"
                                                       :search-input.sync="searchCofins"
                                                    >
                                                    </v-combobox>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" flat @click="close2">Fechar</v-btn>
                                        <v-btn color="blue darken-1" flat @click="save2">Salvar</v-btn>
                                    </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </div>
                        <v-data-table
                            :headers="headers2"
                            :items="cst"
                            class="elevation-1"
                        >
                            <template slot="items" slot-scope="props">
                            <td>{{ props.item.ncm_id.nome }}</td>
                            <td>{{ props.item.cfop.nome }}</td>
                            <td>{{ props.item.cst_icms.nome }}</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                small
                                class="mr-2"
                                @click="editItem2(props.item)"
                                >
                                edit
                                </v-icon>
                                <v-icon
                                    small
                                    @click="deleteItem2(props.item)"
                                >
                                delete
                                </v-icon>
                            </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-tab-item>
        </v-tabs>
        </v-form>
        <v-layout
            class="mt-4"
            row
            align-end
        >
            <v-btn
            class="ml-2"
            color="success"
            @click="criarPosicao"
            >
            Salvar
            </v-btn>

            <v-btn
            color="error"
            @click="reset"
            >
            Cancelar
            </v-btn>

            <v-btn
            color="warning"
            @click="back"
            >
            Voltar
            </v-btn>
        </v-layout>
         <v-layout
            class="mt-4">
            <v-flex xs12 md12>
                <v-textarea
                    v-if="this.envio !== ''"
                    class="mostrar"
                    disabled
                    outline
                    no-resize
                    rows = "5"
                    name="inputEnvio"
                    label="Envio"
                    :value="this.envio"
                ></v-textarea>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md12>
                <v-textarea
                    v-if="this.mostrar !== ''"
                    disabled
                    outline
                    no-resize
                    color="purple"
                    rows = "5"
                    name="inputMostrar"
                    label="Resposta"
                    :value="this.mostrar"
                ></v-textarea>
            </v-flex>
        </v-layout>
      </v-container>

    </v-app>
  </div>
</template>

<script>
    import {sharedService} from '../services'
import alert from '../store/alert';

    export default {
        name: 'PosicaoFiscalForm',
        data() {
            return {
                editedIndex: -1,
                editedIndex2: -1,
                editedIndex3: -1,
                headers1: [
                    {text: 'NCM', align: 'left', value: 'ncm_id'},
                    {text: 'Tributo From', value: 'tributo_from'},
                    {text: 'Tributo To', value: 'tributo_to' }
                ],
                headers2: [
                    {text: 'NCM', align: 'left', value: 'ncm_id'},
                    {text: 'CFOP', value: 'cfop'},
                    {text: 'CST ICMS', value: 'cst_icms' }
                ],
                empresas: '',
                dialog1: false,
                dialog2: false,
                searchEmpresa: '',
                searchNcm: '',
                searchNcmT: '',
                searchTributoTo: '',
                searchTributo: '',
                searchCfop: '',
                searchIcms: '',
                searchIpi: '',
                searchPis: '',
                searchCofins: '',
                loadingNcm: false,
                loadingNcmT: false,
                loadingTributoTo: false,
                loadingTributo: false,
                loadingCfop: false,
                loadingIcms: false,
                loadingIpi: false,
                loadingPis: false,
                loadingCofins: false,
                ncm: [],
                ncmT: [],
                tipoTributos: [],
                tipoTributosTo:[],
                tipoCfop: [],
                tipoIcms: [],
                tipoIpi: [],
                tipoPis: [],
                tipoCofins: [],
                mostrar: '',
                envio: '',
                newPosicao:{
                    codigo: '',
                    empresas_id: {
                        id: '',
                        nome: ''
                    },
                    nome: '',
                    tp_nf: '',
                    tp_finNFe: '',
                    tp_idDest: '',
                    natOpe: '',
                    observacoes: '',
                    troca_tibutos: [],
                    cst: []
                },
                troca_tibutos: [],
                cst: [],
                editedItem: {
                    ncm_id: '',
                    tributo_from: '',
                    tributo_to: ''
                },
                defaultItem: {
                    ncm_id: '',
                    tributo_from: '',
                    tributo_to: ''
                },
                editedItem2: {
                    ncm_id: '',
                    cfop: '',
                    cst_icms: '',
                    cst_ipi: '',
                    cst_pis: '',
                    cst_cofins: ''
                },
                defaultItem2: {
                    ncm_id: '',
                    cfop: '',
                    cst_icms: '',
                    cst_ipi: '',
                    cst_pis: '',
                    cst_cofins: ''
                },
                tipoDocumento: [
                    {id: '55', nome: 'NFe'},
                    {id: '65', nome: 'NFCe'}
                ],
                tipoNota: [
                    {id: '0', nome: 'Entrada'},
                    {id: '1', nome: 'Saída'}
                ],
                tipoFinalidade: [
                    {id: '1', nome: '1-NF-e normal'},
                    {id: '2', nome: '2-NF-e complementar'},
                    {id: '3', nome: '3-NF-e de ajuste'},
                    {id: '4', nome: '4-Devolução'}
                ],
                tipoDestino: [
                    {id: '1', nome: 'Operação interna'},
                    {id: '2', nome: 'Operação interestadual'},
                    {id: '3', nome: 'Operação com exterior'}
                ],
                obrigatorioRules: [
                    v => !!v || 'Este campo é obrigatório'
                ],
                tamanhoRules : [
                    v => v.length <= 15 || 'Máximo 15 caracteres'
                ],
                valid: true,
                text: '',
                empresaTes: ''
            }
        },
        created () {
            if (this.$route.params.id) {
                this.id = this.$route.params.id
                this.editedIndex = 1
                this.getData()
            } else {
                this.editedIndex = -1
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nova Posição Fiscal' : 'Edita Posição Fiscal'
            },
            empresa: function () {
                let self = this
                self.empresaTes = this.$store.getters.getEmpresa
                return this.$store.getters.getEmpresa
            }
        },
        methods: {
            save() {
                if (this.editedIndex2 > -1) {
                    let self = this
                    this.$confirm('Tem certeza que deseja editar este item?').then(res => {
                        if (res) {
                            if(this.editedItem.tributo_from === ''){
                                self.mostrar = 'Preencha os campos obrigatórios(*)!'
                                self.$store.dispatch('error', self.mostrar)
                                this.close()
                                setTimeout(()=>{
                                    self.mostrar = ''
                                },5000)
                            } else{
                                self.troca_tibutos[this.editedIndex2] = Object.assign(this.troca_tibutos[this.editedIndex2], this.editedItem)
                                this.newPosicao.troca_tibutos = self.troca_tibutos
                                this.close()
                            }
                        } else {
                            this.close()
                        }
                    })
                } else {
                    let self = this
                    this.$confirm('Tem certeza que deseja salvar este item?').then(res => {
                        if (res) {
                            if(this.editedItem.tributo_from === ''){
                                self.mostrar = 'Preencha os campos obrigatórios(*)!'
                                self.$store.dispatch('error', self.mostrar)
                                this.close()
                                setTimeout(()=>{
                                    self.mostrar = ''
                                },5000)
                            } else{
                                self.troca_tibutos.push(this.editedItem)
                                this.newPosicao.troca_tibutos = self.troca_tibutos
                                this.close()
                            }
                        } else {
                            this.close()
                        }
                    })
                }
            },
            save2() {
                if (this.editedIndex3 > -1) {
                    let self = this
                    this.$confirm('Tem certeza que deseja editar este item?').then(res => {
                        if (res) {
                            if(this.editedItem2.cfop === '' || this.editedItem2.cst_icms === '' || this.editedItem2.cst_pis === '' || this.editedItem2.cst_ipi === '' || this.editedItem2.cst_cofins === ''){
                                self.mostrar = 'Preencha os campos obrigatórios(*)!'
                                self.$store.dispatch('error', self.mostrar)
                                this.close2()
                                setTimeout(()=>{
                                    self.mostrar = ''
                                },5000)
                            } else{
                                self.cst[this.editedIndex3] = Object.assign(this.cst[this.editedIndex3], this.editedItem2)
                                this.newPosicao.cst = self.cst
                                this.close2()
                            }
                        } else {
                            this.close2()
                        }
                    })
                } else {
                    let self = this
                    this.$confirm('Tem certeza que deseja salvar este item?').then(res => {
                        if (res) {
                            if(this.editedItem2.cfop === '' || this.editedItem2.cst_icms === '' || this.editedItem2.cst_pis === '' || this.editedItem2.cst_ipi === '' || this.editedItem2.cst_cofins === ''){
                                self.mostrar = 'Preencha os campos obrigatórios(*)!'
                                self.$store.dispatch('error', self.mostrar)
                                this.close2()
                                setTimeout(()=>{
                                    self.mostrar = ''
                                },5000)
                            } else{
                                self.cst.push(this.editedItem2)
                                this.newPosicao.cst = self.cst
                                this.close2()
                            }
                        } else {
                            this.close2()
                        }
                    })
                }
            },
            close () {
                this.dialog1 = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex2 = -1
                }, 300)
            },
            close2 () {
                this.dialog2 = false
                setTimeout(() => {
                    this.editedItem2 = Object.assign({}, this.defaultItem2)
                    this.editedIndex3 = -1
                }, 300)
            },
            editItem (item) {
                this.editedIndex2 = this.troca_tibutos.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog1 = true
            },
            editItem2 (item) {
                this.editedIndex3 = this.cst.indexOf(item)
                this.editedItem2 = Object.assign({}, item)
                this.dialog2 = true
            },
            deleteItem (item) {
                let self = this
                this.$confirm('Tem certeza que deseja deletar este item?').then(res => {
                    if (res) {
                        self.troca_tibutos.splice(self.troca_tibutos.indexOf(item), 1)
                        this.close()
                    } else {
                        this.close()
                    }
                })
            },
            deleteItem2 (item) {
                let self = this
                this.$confirm('Tem certeza que deseja deletar este item?').then(res => {
                    if (res) {
                        self.cst.splice(self.cst.indexOf(item), 1)
                        this.close()
                    } else {
                        this.close()
                    }
                })
            },
            criarPosicao() {
                let self = this
                if(this.editedIndex === -1){
                    this.$confirm('Tem certeza que deseja salvar este item?').then(res => {
                        if (res) {
                            if (this.$refs.form.validate()) {
                                sharedService.create('PosicaoFiscal', this.newPosicao).then(function (obj){
                                    self.envio = JSON.stringify(self.newPosicao)
                                    obj.text().then(function (text){
                                        self.mostrar = text
                                        if(obj.status === 200){
                                            self.$store.dispatch('success', 'Posição Fiscal cadastrada com sucesso!')
                                        }  else {
                                            self.$store.dispatch('error', text)
                                        }
                                    })
                                })
                            } else {
                                alert('Preencha os campos obrigatórios!')
                            }
                        } else {
                            this.close()
                        }
                    })
                } else {
                        this.$confirm('Tem certeza que deseja editar este item?').then(res => {
                        if (res) {
                            if (this.$refs.form.validate()) {
                                sharedService.update('PosicaoFiscal', this.newPosicao, this.id).then(function (obj){
                                    self.envio = JSON.stringify(self.newPosicao)
                                    obj.text().then(function (text){
                                        self.mostrar = text
                                        if(obj.status === 200){
                                            self.$store.dispatch('success', 'Posição fiscal editado com sucesso!')
                                        }  else {
                                            self.$store.dispatch('error', text)
                                        }
                                    })
                                })
                            } else {
                                alert('Preencha os campos obrigatórios!')
                            }
                        } else {
                            this.close()
                        }
                    })
                }
            },
            back () {
                this.$router.push({
                name: 'PosicaoFiscal'
                })
            },
            reset () {
                this.$refs.form.reset()
            },
            getData: async function () {
                let self = this
                await sharedService.read('PosicaoFiscal',{atributos: ['id','nome']}, this.id).then(function (obj){
                    self.newPosicao.codigo           = obj.codigo
                    self.newPosicao.empresas_id.nome = obj.empresas_id.nome
                    self.newPosicao.nome             = obj.nome
                    self.newPosicao.tp_doc           = obj.tp_doc
                    self.newPosicao.tp_nf            = obj.tp_nf
                    self.newPosicao.tp_finNFe        = obj.tp_finNFe
                    self.newPosicao.tp_idDest        = obj.tp_idDest
                    self.newPosicao.natOpe           = obj.natOpe
                    self.newPosicao.observacoes      = obj.observacoes
                    self.troca_tibutos               = obj.troca_tibutos
                    self.newPosicao.troca_tibutos    = self.troca_tibutos
                    self.cst                         = obj.cst
                    self.newPosicao.cst              = self.cst
                })
            },
            getEmpresa () {
                let self = this
                let busca = 'filtros=[["nome_fantasia","like","'+self.empresaTes.nome+'%"]]'

                sharedService.read('Empresas?'+busca).then(function (obj){
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome_fantasia
                        }
                        self.newPosicao.empresas_id.id = obje.id
                        self.newPosicao.empresas_id.nome = obje.nome
                    }
                })
            }
        },
        watch: {
            searchNcmT (val) {
                let self = this
                this.loadingNcmT = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('NCMEmpresa?'+busca).then(function (obj){
                    self.ncmT = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].ncm_id.id,
                            nome: obj.obj[key].ncm_id.nome
                        }
                        self.ncmT.push(obje)
                    }
                    self.loadingNcmT = false
                })
            },
            searchNcm (val) {
                let self = this
                this.loadingNcm = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('NCMEmpresa?'+busca).then(function (obj){
                    self.ncm = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].ncm_id.id,
                            nome: obj.obj[key].ncm_id.nome
                        }
                        self.ncm.push(obje)
                    }
                    self.loadingNcm = false
                })
            },
            searchTributo (val) {
                let self = this
                this.loadingTributo = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('Tributos?'+busca).then(function (obj){
                    self.tipoTributos = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome
                        }
                        self.tipoTributos.push(obje)
                    }
                    self.loadingTributo = false
                })
            },
            searchTributoTo (val) {
                let self = this
                this.loadingTributoTo = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('Tributos?'+busca).then(function (obj){
                    self.tipoTributosTo = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome
                        }
                        self.tipoTributosTo.push(obje)
                    }
                    self.loadingTributoTo = false
                })
            },
            searchCfop (val) {
                let self = this
                this.loadingCfop = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('CFOP?'+busca).then(function (obj){
                    self.tipoCfop = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome
                        }
                        self.tipoCfop.push(obje)
                    }
                    self.loadingCfop = false
                })
            },
            searchIcms (val) {
                let self = this
                this.loadingIcms = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('CstIcms?'+busca).then(function (obj){
                    self.tipoIcms = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome
                        }
                        self.tipoIcms.push(obje)
                    }
                    self.loadingIcms = false
                })
            },
            searchIpi (val) {
                let self = this
                this.loadingIpi = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('CstIpi?'+busca).then(function (obj){
                    self.tipoIpi = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome
                        }
                        self.tipoIpi.push(obje)
                    }
                    self.loadingIpi = false
                })
            },
            searchPis (val) {
                let self = this
                this.loadingPis = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('CstPis?'+busca).then(function (obj){
                    self.tipoPis = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome
                        }
                        self.tipoPis.push(obje)
                    }
                    self.loadingPis = false
                })
            },
            searchCofins (val) {
                let self = this
                this.loadingCofins = true

                let busca
                if(val === null || val === ''){
                    busca = 'limit=10'
                } else {
                    busca = 'filtros=[["nome","like","'+val+'%"]]'
                }

                sharedService.read('CstCofins?'+busca).then(function (obj){
                    self.tipoCofins = []
                    for (var key in obj.obj) {
                        let obje = {
                            id: obj.obj[key].id,
                            nome: obj.obj[key].nome
                        }
                        self.tipoCofins.push(obje)
                    }
                    self.loadingCofins = false
                })
            },
            empresa: function () {
                if(this.empresa){
                    this.empresaTes = this.empresa
                    this.getEmpresa()
                }
            }
        },
        beforeMount(){
            this.getEmpresa()
        }
    }
</script>

<style scoped>

</style>
